import Plot from 'react-plotly.js';

interface GraficoSecaoProps {
	dta: any;
}

export default function GraficoSecao({dta}: GraficoSecaoProps) {

  return (
    <Plot
      data={dta.data}
      layout={dta.layout}
      config={{
        responsive: true,
        displaylogo: false,
      }}
      style={{ width: '100%', height: '100%' }}
    />
  );
}
